exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table__body[data-v-0777705b] {\n  width: 100%;\n  table-layout: fixed !important;\n}\n.text_overflow[data-v-0777705b] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 400px;\n}\n.pup_card[data-v-0777705b] {\n  width: 200px;\n  border-radius: 5px;\n  padding: 5px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-size: 12px;\n  line-height: 16px;\n}\n.mt10[data-v-0777705b] {\n  margin-top: 10px;\n}\n", ""]);

// exports
